/* Leave the native Chatsi tab and chat untouched; add a sibling tuck control. */
(() => {
  'use strict';
  const dock=document.getElementById('ts-chatsi-dock');
  if(!dock||dock.dataset.initialized)return;
  dock.dataset.initialized='true';
  const button=dock.querySelector('.ts-chatsi-tuck');
  let container=null, observer=null, sizeObserver=null, tucked=false;
  try{tucked=sessionStorage.getItem('ts-chatsi-tucked')==='true';}catch(_){}
  function sync(){
    const ready=container?.isConnected&&container.dataset.ready==='1';
    const closed=ready&&container.classList.contains('widget-closed');
    dock.hidden=!closed;
    document.documentElement.classList.toggle('ts-chatsi-tucked',Boolean(ready&&tucked));
    dock.dataset.tucked=String(tucked);
    button.setAttribute('aria-expanded',String(!tucked));
    const label=tucked?'Show AI Chat Bot':'Collapse AI Chat Bot';
    button.setAttribute('aria-label',label);button.title=label;
    if(closed){
      const box=container.getBoundingClientRect();
      dock.style.right=tucked?'0px':`${Math.max(0,document.documentElement.clientWidth-box.left)}px`;
      dock.style.top=`${Math.min(window.innerHeight-48,Math.max(4,box.top+box.height/2-22))}px`;
    }
  }
  button.addEventListener('click',()=>{tucked=!tucked;try{sessionStorage.setItem('ts-chatsi-tucked',String(tucked));}catch(_){}sync();});
  function attach(){
    const next=document.getElementById('chatsi-widget-container');
    if(next===container)return;
    observer?.disconnect();sizeObserver?.disconnect();container=next;
    if(container){
      observer=new MutationObserver(sync);observer.observe(container,{attributes:true,attributeFilter:['class','data-ready','style']});
      if('ResizeObserver'in window){sizeObserver=new ResizeObserver(sync);sizeObserver.observe(container);}
    }
    sync();
  }
  new MutationObserver(attach).observe(document.body,{childList:true});
  window.addEventListener('resize',sync,{passive:true});attach();
})();
